import classNames from 'classnames';
import React from 'react';

import { IconTypes } from '@eika/icon';
import { IconLink, Link } from '@eika/link';
import { ListPanelWrapper } from '@eika/link-panel';

import AccountCardList from '../../../../components/AccountList/AccountCardList';
import { useConfig } from '../../../../defaultConfig';
import useTranslation from '../../../../hooks/useTranslation';
import { AccountCardItem } from '../../../../models/account';
import { favoriteAccountsSelector } from '../../favoriteAccountSelector';

type Props = {
    accountCardItems: AccountCardItem[];
    header: string;
    showHasMore?: boolean;
};

export function AccountOverviewContent({ accountCardItems, header, showHasMore = false }: Props) {
    const translated = useTranslation();
    const { accountLink, editAccountsLink, allAccountsLink } = useConfig();

    const visibleAccounts = favoriteAccountsSelector(accountCardItems);

    return (
        <ListPanelWrapper
            className="sgw-content account-overview"
            data-testid="account-overview-list"
            titleContent={
                <div className="account-overview-title-wrapper">
                    <div
                        className={classNames('account-overview__header-container', {
                            'account-overview__header-container__no-edit-link': !editAccountsLink,
                        })}
                    >
                        <h2 className="account-overview__header typography-subtitle-bold">{header}</h2>
                        {editAccountsLink && (
                            <IconLink
                                label={translated.editAccounts.view}
                                icon={IconTypes.PENN_24}
                                href={editAccountsLink.url}
                                className="account-overview__button-icon"
                            />
                        )}
                    </div>
                </div>
            }
            footerContent={
                showHasMore && (
                    <div className="account-overview__bottomlink">
                        <Link icon={IconTypes.BUET_PIL_HOEYRE_20} href={allAccountsLink.url}>
                            {translated.seeAllAccounts}
                        </Link>
                    </div>
                )
            }
            contentWrapperAs="ol"
        >
            <AccountCardList detailsLink={accountLink?.url} accountCards={visibleAccounts} />
        </ListPanelWrapper>
    );
}
